import { Component, DestroyRef, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { RnUsersVM } from '../../../services/rnapi2-service/models/models';
import { OrgRenameUserLoggedInConfig } from './rename-error-config';
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { FolderOrgRenameErrorModalService } from './folder-org-rename-error-modal.service';
import { ModalState } from 'src/app/shared/services/base-modal/base-modal.service';

@Component({
  selector: 'app-org-close-folder-rename-error-modal',
  templateUrl: './rename-error.component.html',
  styleUrls: ['./rename-error.component.scss'],
  standalone: false
})
export class OrgRenameUserLoggedInDialogComponent implements OnInit {
  @ViewChild('modalRef') modal: ModalComponent;
  type: string;
  verb: string;
  usersLoggedIn: RnUsersVM[];
  private readonly folderOrgRenameErrorModalService = inject(FolderOrgRenameErrorModalService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.subscribeModalService();
  }

  subscribeModalService(): void {
    this.folderOrgRenameErrorModalService.modalState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: ModalState<OrgRenameUserLoggedInConfig>) => {
        if (!data?.config) {
          return;
        }
        this.type = data.config.type;
        this.verb = data.config.verb;
        this.usersLoggedIn = data.config.users.sort((u1, u2) => {
          const orgComp = u1.OrganizationName.localeCompare(u2.OrganizationName);
          if (orgComp === 0) {
            return u1.FullName.localeCompare(u2.FullName);
          }
          return orgComp;
        });

        if (data?.isOpen) {
          this.open();
        } else {
          this.close();
        }
      }
    );
  }

  open(): void {
    this.modal?.open();
  }

  close() {
    this.modal?.close();
  }
}
